<script setup lang="ts">
import { computed } from "vue";

import { useRoute } from "vue-router";
import { useGetDiagnostic } from "@/stores/queries";

const route = useRoute();

const diagId = computed(() => {
  return route.params.id ? Number(route.params.id) : undefined;
});

const { data: diagnostic } = useGetDiagnostic(diagId);

const project = computed(() => {
  return diagnostic.value?.project;
});
</script>

<template>
  <el-breadcrumb separator="/">
    <el-breadcrumb-item
      :to="{
        name: 'projects',
      }"
      >{{ $t("dashboard:navigation.projects") }}</el-breadcrumb-item
    >
    <el-breadcrumb-item
      v-if="project"
      :to="{
        name: 'project',
        params: { id: project.id },
      }"
      >{{ project.name }}</el-breadcrumb-item
    >
    <el-breadcrumb-item v-if="diagnostic">{{
      diagnostic.name ?? $t("noname")
    }}</el-breadcrumb-item>
  </el-breadcrumb>
</template>

<style lang="scss" scoped></style>
